import api from '@shared/api';

const notesApi = {
  fetchProjectNote(projectId) {
    const url = `notes/project/get?projectId=${projectId}`;
    return api.get(url);
  },

  saveProjectNote(data) {
    const url = `notes/project/update`;
    return api.post(url, data);
  }
};

export default notesApi;
